import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "./EmbedReports.scss";

const EmbedReports = ({embedUrl,repordId,token}) => {
  return (
    <>
      <PowerBIEmbed
        embedConfig={{
          type: "report",
          id:repordId,
          embedUrl,
          accessToken:token,
          tokenType: models.TokenType.Embed,
          settings: {
            panes: {
              filters: { visible: false },
              pageNavigation: { visible: true },
            },
          },
        }}
        eventHandlers={
          new Map([
            // ["loaded", () => console.log("Report loaded")],
            ["error", (e) => console.error("Power BI error", e.detail)],
          ])
        }
        cssClassName="report-container"
      />
    </>
  );
};


export default EmbedReports;
